import React, { useEffect, useState } from "react";
import Web3 from "web3";
import diamond from "../assets/img/tiers/diamond.svg";
import bsc from "../assets/img/chains/bsc.png";
import launchpadIcon from "../assets/img/icons/launchpad.svg";
import telegramIcon from "../assets/img/icons/telegram.svg";
import xIcon from "../assets/img/icons/x.svg";

function SpecialSalePad() {
  const [walletBalance, setWalletBalance] = useState(0);
  const [isSaleActive, setIsSaleActive] = useState(false);
  const [progress, setProgress] = useState(0);
  const [saleStartTime, setSaleStartTime] = useState(Date.now());
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    async function checkWalletBalance() {
      try {
        const web3 = new Web3(window.ethereum);
        const balance = await web3.eth.getBalance(
          "0x6A31f1F6D82F640155893F851C6d25D448c2d7Dd"
        );
        const balanceInEther = parseFloat(web3.utils.fromWei(balance, "ether"));
        setWalletBalance(balanceInEther);
        setProgress((balanceInEther / 10) * 100);
      } catch (error) {
        console.error("Error fetching wallet balance:", error);
      }
    }

    const today = new Date();
    const saleStartDate = new Date("2023-12-20");
    const saleEndDate = new Date("2024-01-20");
    const isActiveDate = today >= saleStartDate && today <= saleEndDate;

    setIsSaleActive(isActiveDate);
    setSaleStartTime(saleStartDate.getTime());

    checkWalletBalance();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      const now = Date.now();
      const distance = saleStartTime - now;

      setTimeLeft(distance);

      if (distance <= 0) {
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [saleStartTime]);

  async function enviarBNB(cantidad) {
    try {
      const web3 = new Web3(window.ethereum);
      const accounts = await web3.eth.getAccounts();
      if (accounts.length === 0) {
        alert("Please connect your wallet to continue");
        return;
      }

      if (cantidad < 0.1 || cantidad > 0.25) {
        alert("The amount should be between 0.1 and 0.25 BNB");
        return;
      }

      const amountToSend = web3.utils.toWei(cantidad.toString(), "ether");
      const addressToSend = "0x6A31f1F6D82F640155893F851C6d25D448c2d7Dd";

      await web3.eth.sendTransaction({
        to: addressToSend,
        from: accounts[0],
        value: amountToSend,
      });

      alert(`${cantidad} BNB sent successfully`);
    } catch (error) {
      console.error("Error sending BNB:", error);
      alert("There was an error sending BNB");
    }
  }

  return (
    <div className="special-sale-pad">
      <div className="tier">
        <img src={diamond} alt="diamond" />
      </div>
      <div className="section-1">
        <div className="avatar">
          <img src="https://i.ibb.co/DCSXfXP/PKM.png" alt="avatar" />
        </div>
        <div className="status">
          <div className="kyc">KYC</div>
          <div className="audit">Audit</div>
          <div className="vetted">VETTED</div>
          <div className="live">Progress</div>
        </div>
      </div>
      <div className="section-2">
        <div className="left">
          <div className="title">Viltrumita</div>
          <div className="type">
            Max Contribution: 25.0 BNB
            <ul>
              <li>Token Name: Viltrumita</li>
              <li>Token Symbol: VLT</li>
              <li>Token Decimals: 18</li>
              <li>
                Token Address: 0x71525c2538c957EEaF537ECa29381447adDb8f76 (Do
                not send BNB to the token address!)
              </li>
              <li>Total Supply: 100,000,000 VLT</li>
              <li>Tokens For Presale: 25,000,000 VLT</li>
              <li>Tokens For Liquidity: 74,000,000 VLT</li>
              <li>Tokens For Reward Pool: 1,000,000 VLT</li>
              <li>Initial Market Cap (estimate): $24,148</li>
              <li>Soft Cap: 100 BNB</li>
              <li>Presale Start Time: 2023.12.20 10:00 (UTC)</li>
              <li>Presale End Time: 2024.01.20 10:00 (UTC)</li>
              <li>Listing On: Pancakeswap</li>
              <li>Liquidity Percent: 74%</li>
              <li>Liquidity Lockup Time: 10000 days after pool ends</li>
            </ul>
          </div>
        </div>
        <div className="right">
          <img src={bsc} alt="BSC" />
        </div>
      </div>
      <div className="progress-bar">
        <div className="progress" style={{ width: `${progress}%` }}></div>
      </div>
      <div className="cap">
        <span className="key">Hard Cap:</span>
        <span className="value">500.0 BNB</span>
      </div>
      <div className="cap">
        <span className="key">Soft Cap:</span>
        <span className="value">100.0 BNB</span>
      </div>
      <div className="hr" />
      <div className="pre-sale-info">
        <div className="pre-sale-header">Cryptomine Space X Ecosystem</div>
        <div className="pre-sale-details">
          <div className="pre-sale-item">
            <span>Launchpad - Max buy 0.25 BNB</span>
          </div>
          <div className="pre-sale-item">
            <span>Soft Cap: 100 BNB-</span>
            <span>Progress ({progress.toFixed(2)}%)</span>
            <div className="progress"></div>
          </div>
          <div className="pre-sale-item"></div>
          <div className="pre-sale-item"></div>
          {isSaleActive && (
            <div className="pre-sale-item">
              <span>Sale Starts In:</span>
              <span>{new Date(timeLeft).toISOString().substr(11, 8)}</span>
            </div>
          )}
        </div>
        <div className="pre-sale-actions">
          <button
            className="default-btn"
            onClick={() => {
              const cantidadBNB = prompt(
                "Enter the amount of BNB to send (between 0.1 and 0.25) 0.1 BNB would be exchanged for 200 VLT, 0.25 BNB would be exchanged for 500 VLT"
              );
              if (cantidadBNB !== null) {
                enviarBNB(parseFloat(cantidadBNB));
              }
            }}
          >
            Buy with BNB
          </button>
          <div className="social-links">
            <a
              href="https://csxp.netlify.app/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img className="btn" src={launchpadIcon} alt="launchpad Icon" />
            </a>
            <a
              href="https://t.me/CSPX_Ecosystem"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img className="btn" src={telegramIcon} alt="Telegram Icon" />
            </a>
            <a
              href="https://twitter.com/Cryptominespace"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img className="btn" src={xIcon} alt="x Icon" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SpecialSalePad;
